// components/FilaComentario.tsx
import { useEffect, useState } from "react";
import { Box, IconButton, TextField, Tooltip } from "@mui/material";
import { IconCheck, IconMessage } from "@tabler/icons-react";
import {
    MAX_COMENTARIO,
    MENSAJE_COMENTARIO_OBLIGATORIO,
} from "../constants/productoSeleccionado.constants";

interface FilaComentarioProps {
    comentarios?: string;
    obligatorio?: boolean;
    deshabilitado?: boolean;
    enfocar?: boolean;
    onGuardar: (texto: string) => void;
}

export const FilaComentario = ({
    comentarios = "",
    obligatorio = false,
    deshabilitado = false,
    enfocar = false,
    onGuardar,
}: FilaComentarioProps): JSX.Element => {
    const [texto, setTexto] = useState(comentarios);
    useEffect(() => setTexto(comentarios), [comentarios]);

    const limpio = texto.trim();
    const falta = obligatorio && !limpio;
    const hayCambios = limpio !== comentarios.trim();
    const puedeGuardar = !deshabilitado && hayCambios && !falta;

    const guardar = () => {
        if (puedeGuardar) onGuardar(limpio);
    };

    const textoAyuda = falta
        ? MENSAJE_COMENTARIO_OBLIGATORIO
        : hayCambios
            ? "Sin guardar · Enter para guardar, Shift+Enter para salto de línea"
            : `${texto.length}/${MAX_COMENTARIO}`;

    return (
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
            <IconMessage size={18} stroke={2} color="#4a6fa5" style={{ marginTop: 10, flexShrink: 0 }} />
            <TextField
                fullWidth
                multiline
                maxRows={3}
                size="small"
                autoFocus={enfocar}
                placeholder={obligatorio ? "Comentario (obligatorio)" : "Comentario"}
                value={texto}
                disabled={deshabilitado}
                error={falta}
                helperText={textoAyuda}
                onChange={(e) => setTexto(e.target.value.slice(0, MAX_COMENTARIO))}
                onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        guardar();
                    }
                }}
            />
            <Tooltip title="Guardar comentario">
                <span>
                    <IconButton
                        onClick={guardar}
                        disabled={!puedeGuardar}
                        aria-label="Guardar comentario"
                        sx={{ mt: 0.25 }}
                    >
                        <IconCheck stroke={2.5} color={puedeGuardar ? "#6aa84f" : "#a7a7a7"} />
                    </IconButton>
                </span>
            </Tooltip>
        </Box>
    );
};